import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        @media (max-width: 768px) {
            padding: 40px 16px;
        }

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.2em;
                }

                @media (max-width: 480px) {
                    font-size: 1.75em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;

        @media (max-width: 768px) {
            font-size: 0.95em;
            gap: 6px;
        }
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 900px;
        margin: -40px auto 0;
        padding: 0 20px;
        position: relative;
        z-index: 10;
        box-sizing: border-box;

        @media (max-width: 768px) {
            margin: -24px auto 0;
            padding: 0 12px;
        }
        
        .contact-container {
            background: white;
            border-radius: 24px;
            padding: 50px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            margin-bottom: 40px;
            box-sizing: border-box;

            @media (max-width: 768px) {
                padding: 24px 16px;
                border-radius: 18px;
                margin-bottom: 24px;
            }

            .section-header {
                text-align: center;
                margin-bottom: 40px;

                @media (max-width: 768px) {
                    margin-bottom: 24px;
                }

                h2 {
                    font-size: 2em;
                    font-weight: 700;
                    color: #1e293b;
                    margin: 0;

                    @media (max-width: 768px) {
                        font-size: 1.4em;
                    }
                }
            }

            .form, .formEn {
                display: grid;
                grid-gap: 20px;
                grid-template-columns: 1fr 1fr;
                
                @media (max-width: 768px) {
                    grid-template-columns: 1fr;
                    grid-gap: 14px;
                }

                input, textarea {
                    width: 100%;
                    padding: 16px 20px;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    background: #f8fafc;
                    font-size: 1em;
                    font-family: inherit;
                    color: #334155;
                    transition: all 0.3s ease;
                    box-sizing: border-box;

                    @media (max-width: 768px) {
                        padding: 14px 16px;
                        font-size: 0.95em;
                    }

                    &:focus {
                        outline: none;
                        border-color: #00A9C4;
                        background: #fff;
                        box-shadow: 0 0 0 4px rgba(0, 169, 196, 0.1);
                    }
                    
                    &::placeholder {
                        color: #94a3b8;
                    }
                }

                textarea {
                    grid-column: 1 / -1;
                    min-height: 150px;
                    resize: vertical;

                    @media (max-width: 768px) {
                        min-height: 120px;
                    }
                }

                button {
                    grid-column: 1 / -1;
                    background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
                    color: white;
                    border: none;
                    border-radius: 12px;
                    padding: 18px;
                    font-size: 1.1em;
                    font-weight: 600;
                    cursor: pointer;
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                    box-shadow: 0 10px 20px rgba(0, 169, 196, 0.2);

                    @media (max-width: 768px) {
                        padding: 14px;
                        font-size: 1em;
                    }

                    &:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 15px 30px rgba(0, 169, 196, 0.3);
                    }

                    &:active {
                        transform: translateY(0);
                    }
                }
            }
        }
    `
};

export default S;